/* shb-koszyk-set, zrodlo zrodla-js */
(function (){
var W=window,C;try{C=JSON.parse(document.getElementById('shb-ks-cfg').textContent);}catch(e){return;}
var SOFA={8723139297614:'pure-corduroy',8579469967694:'original',8990122836302:'waffle',8655956148558:'teddy'};
var ADD=[8736335364430,8388183097678,9697586676046,9697584382286,10711681597774,10715007680846,10715008762190,10715006927182,16023897440590];
var KUMO=[10861120880974,15743373181262],MINI=[8827537752398,9709520519502];
var D=document,T=C.t||{},lg=D.documentElement.lang||'en',hint=null,mo=null;
function fm(c){try{return new Intl.NumberFormat(lg,{style:'currency',currency:C.cur,maximumFractionDigits:0}).format(c / 100);}catch(e){return c / 100+' '+C.cur;}}
function col(it){var c='';(it.optionsWithValues||[]).forEach(function (o){if(/^(color|colour|farbe|kleur|couleur|kolor|colore)$/i.test(String(o.name).trim()))c=String(o.value).toLowerCase();});return c;}
function url(v,it,fk){return C.root+'/pages/sofa-guide?view='+v+(fk?'&stoff='+fk:'')+'&kolor='+encodeURIComponent(col(it));}
function pick(items){
var ids=(items||[]).map(function (i){return+i.productId;}),s,k,m;
(items||[]).forEach(function (i){var p=+i.productId;if(!s&&SOFA[p])s=i;if(!k&&p===KUMO[0])k=i;if(!m&&p===MINI[0])m=i;});
function has(l){return ids.some(function (p){return l.indexOf(p)>-1;});}
if(s&&!has(ADD)){var fk=SOFA[+s.productId],nf=fk !=='pure-corduroy',t=C.fx.s?T[nf?'sofa_fx_nf':'sofa_fx']:T[nf?'sofa_nf':'sofa'];
return t?{t:t.replace('%amount%',fm(C.fx.s)),u:url('bundle-sofa160-arches',s,fk)}:null;}
if(k&&C.fx.k&&ids.indexOf(KUMO[1])<0&&T.kumo)return {t:T.kumo.replace('%amount%',fm(C.fx.k)),u:url('bundle-kumo',k)};
if(m&&C.fx.m&&ids.indexOf(MINI[1])<0&&T.mini)return {t:T.mini.replace('%amount%',fm(C.fx.m)),u:url('bundle-mini',m)};
return null;
}
function draw(){
var R=W.upcartDocumentOrShadowRoot;if(!R)return;
var old=R.getElementById('shb-ks'),btn=R.querySelector('.upcart-footer [class*="Footer__checkoutButton"]');
if(!hint||!btn){if(old)old.remove();return;}
if(old&&old.nextElementSibling===btn&&old.dataset.u===hint.u)return;
if(old)old.remove();
var p=D.createElement('p');p.id='shb-ks';p.dataset.u=hint.u;
p.setAttribute('style','margin:0 0 10px;padding:10px 12px;border-radius:6px;background:#f6f2ec;color:#211f1c;font-size:13px;line-height:1.4');
p.textContent=hint.t+' ';
var a=D.createElement('a');a.href=hint.u;a.textContent=(T.link||'')+' →';
a.setAttribute('style','color:#211f1c;font-weight:600;text-decoration:underline;text-underline-offset:3px;white-space:nowrap');
p.appendChild(a);btn.parentNode.insertBefore(p,btn);
}
function on(d){hint=pick(d&&d.cart&&d.cart.items);draw();
var R=W.upcartDocumentOrShadowRoot;if(!mo&&R&&R !==document){var q=0;mo=new MutationObserver(function (){if(!q)q=requestAnimationFrame(function (){q=0;draw();});});mo.observe(R,{childList:true,subtree:true});}}
var n=0;(function start(){
if(typeof W.upcartSubscribeCartUpdated !=='function'){if(n++<40)setTimeout(start,500);return;}
W.upcartSubscribeCartLoaded(on);W.upcartSubscribeCartUpdated(on);
var c=W.upcartGetCart&&W.upcartGetCart();if(c)on({cart:c});
})();
})();
